<svelte:head>
	<title>Math Bounty: {qnNumber}</title>
</svelte:head>

<script lang="ts">
	let qnNumber = "2104" // change this
	let topic = "Permutations and combinations" // change this

	let topBarTitle = topic +': Qn ' +qnNumber;
	
	import Tabs from './Tabs.svelte';
	import AfterTabs from './AfterTabs.svelte';

	import TopAppBar, {Row, Section, Title} from '@smui/top-app-bar';
	import Button, {Label} from '@smui/button';
	import IconButton from '@smui/icon-button';
	import Drawer, {AppContent, Content, Header, Subtitle, Scrim} from '@smui/drawer';
	import Fa from 'svelte-fa/dist/svelte-fa';
	import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
	let myDrawer2;
	let myDrawer2Open = false;
	function visitHomepage() {
		window.open('http://mathbounty.adotb.xyz');
	}
</script>

<div class="drawer-container">
	<Drawer variant="modal" bind:this={myDrawer2} bind:open={myDrawer2Open}>
		<Header>
			<Title>Math Bounty</Title>
			<Subtitle>A bounty of questions</Subtitle>
		</Header>
		<Content>
			<Button on:click={visitHomepage} variant="outlined" style="width:100%">
				<div style="font-size:1.5em; margin-right:1em">
					<Fa icon={faHome}></Fa>
				</div>
				<Label>Return Home</Label>
			</Button>
			<p> 
				This is Math Bounty, created by Kelvin Soh. 
			</p>
			<p>
				I teach primarily JC Math in Singapore.
			</p>
			<p>
				Reach me at 
				<a href="mailto:kelvinsohmath@gmail.com">kelvinsohmath@gmail.com</a>
			</p>
		</Content>
	</Drawer>
	<Scrim />

	<AppContent class="app-content">
		<main class="main-content">
			<section>
				<div class="flexy">
					<div class="top-app-bar-container flexor">
						<TopAppBar variant="static">
							<Row>
								<Section>
									<IconButton on:click={() => myDrawer2Open = !myDrawer2Open}>
										<div style="font-size:1.5em">
											<Fa icon={faHome}></Fa>
										</div>
									</IconButton>
									<Title>{topBarTitle}</Title> 
								</Section>
								<Section align="end" toolbar>
									<!-- <IconButton class="material-icons" aria-label="Download">file_download</IconButton>-->
								</Section>
							</Row>
						</TopAppBar>
						<div class="flexor-content">
							<Tabs {qnNumber}/>
						</div>
					</div>
				</div>
			</section>
			<AfterTabs/>
    </main>
  </AppContent>
</div>
<style>
  .top-app-bar-container {
    max-width: 480px;
    min-width: 480px;
    height: 320px;
    border: 1px solid rgba(0,0,0,.1);
    margin: 0 18px 18px 0;
  }
  .top-app-bar-container {
    overflow: auto;
    display: inline-block;
  }
  .flexy {
    display: flex;
    flex-wrap: wrap;
  }
  .flexor {
    display: inline-flex;
    flex-direction: column;
  }
  .flexor-content {
    flex-basis: 0;
    height: 0;
    flex-grow: 1;
		overflow: auto;
	}
  .drawer-container {
    position: relative;
    display: flex;
    height: 350px;
    max-width: 600px;
    border: 1px solid rgba(0,0,0,.1);
    overflow: hidden;
    z-index: 0;
  }
  * :global(.mdc-drawer--modal, .mdc-drawer-scrim) {
    /* This is not needed for a page-wide modal. */
    position: absolute;
  }
  * :global(.app-content) {
    flex: auto;
    overflow: auto;
    position: relative;
    flex-grow: 1;
  }
  .main-content {
    overflow: auto;
    padding: 16px;
    height: 100%;
    box-sizing: border-box;
  }
</style>